var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "get-styled-container page-container" },
    [
      _c(
        "router-link",
        {
          staticClass: "back-to-outfit gray-bottom-border",
          attrs: { to: "/saved-outfits" }
        },
        [
          _c("div", { staticClass: "wtw-container" }, [
            _c("span", { staticClass: "stay-black" }, [
              _vm._v("Back to Saved Outfits")
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("outfit", { ref: "outfitSwipe" }),
      _vm._v(" "),
      _c("shop-items", {
        attrs: {
          outfitCurrent: _vm.outfitCurrent,
          showShopItems: _vm.showShopItems
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-408df40e", { render: render, staticRenderFns: staticRenderFns })
  }
}